module.exports = __webpack_public_path__ + "img/mines.91c3d383.png";